// Legacy WordPress URL paths from crossfitbostonirongrit.com mapped to new routes.
// Used by the catch-all route to land old links on the right page.

export const LEGACY_REDIRECTS = {
  "/visceral-fat-understanding-how-it-affects-your-health-now-and-in-the-future": "/blog/visceral-fat-guide",
  "/olympic-lifting-in-boston-ma": "/classes/olympic-weightlifting",
  "/personnel/tina-ramos": "/coaches/tina-ramos",
  "/personnel/brian-conroy": "/coaches/brian-conroy",
  "/personnel/miguel-claravall": "/coaches/miguel-claravall",
  "/personnel/yohanna": "/coaches/yohanna-estime",
  "/personnel/yohanna-estime": "/coaches/yohanna-estime",
  "/protein-essential-amino-acids": "/blog/essential-amino-acids-protein-guide",
  "/training-for-life-zone-2": "/blog/zone-2-training-guide",
  "/about-our-gym-in-boston-ma": "/about",
  "/teen-strength-conditioning-in-boston-ma": "/classes",
  "/boston-gym-schedule": "/schedule",
  "/contact-our-gym-in-boston-ma": "/contact",
  "/what-our-gym-in-boston-ma-offers": "/classes",
  "/something-about-mary": "/blog/spotlight-mary",
  "/crossfit-open-pop-vs-sop": "/blog/crossfit-open-pop-vs-sop",
  "/crossfit-in-boston-ma": "/classes/crossfit",
  "/fundamentals-assessment-in-boston-ma": "/classes/fundamentals",
  "/inbody-testing-in-boston-ma": "/classes/inbody-testing",
  "/nutrition-coaching-in-boston-ma": "/classes/nutrition-coaching",
  "/iron-grit-blog": "/blog",
  "/peptides-the-wild-wild-west": "/blog/peptides-guide",
  "/zero-proof": "/live-big-365",
  "/next-action-pr": "/get-started",
  "/next-action-drop-in": "/drop-in",
  "/timetable/event/big-engine": "/classes/big-engine",
  "/timetable/event/olympic-lifting": "/classes/olympic-weightlifting",
  "/timetable/event/open-gym": "/classes/open-gym",
  "/timetable/event/ladies-powerlifting": "/classes/powerlifting",
  "/timetable/event/evolve": "/classes",
  "/timetable/event/yoga": "/classes",
  "/get-started/evolve": "/classes",
  "/get-started/open-gym-2": "/classes/open-gym",
  "/category/blog/livelifeoptimal": "/live-big-365",
};

const WILDCARD_REDIRECTS = [
  [/^\/personnel(\/|$)/, "/about"],
  [/^\/20\d{2}(\/|$)/, "/blog"],
  [/^\/tag(\/|$)/, "/blog"],
  [/^\/category(\/|$)/, "/blog"],
  [/^\/author(\/|$)/, "/blog"],
  [/^\/timetable(\/|$)/, "/schedule"],
  [/^\/(feed|comments|wp-json|wp-content|wp-admin|wp-login)(\/|$|\.)/, "/"],
];

export function resolveLegacyPath(pathname) {
  const p = (pathname || "/").toLowerCase().replace(/\/+$/, "") || "/";
  if (LEGACY_REDIRECTS[p]) return LEGACY_REDIRECTS[p];
  for (const [re, to] of WILDCARD_REDIRECTS) {
    if (re.test(p)) return to;
  }
  return null;
}
